import { createSlice } from "@reduxjs/toolkit";

const layoutSlice = createSlice({
  name: "layout",
  initialState: {
    currentScreenWidth: window.innerWidth,
    isLoader: false,
    onLineStatus: false,
    invoiceDtl: null,
  },

  reducers: {
    handleScreenWidth: (state, action) => {
      state.currentScreenWidth = action.payload;
    },
    handleLoader: (state, action) => {
      state.isLoader = action.payload;
    },
    handleInvoiceDtl: (state, action) => {
      state.invoiceDtl = action.payload;
    },
  },
});

export const {
  handleScreenWidth,
  handleLoader,
  handleInvoiceDtl
} = layoutSlice.actions;

export default layoutSlice.reducer;
